/* unplugin-vue-components disabled */import { render } from "./message-api.vue?vue&type=template&id=1064ada8"
import script from "./message-api.vue?vue&type=script&lang=js"
export * from "./message-api.vue?vue&type=script&lang=js"

import exportComponent from "E:\\guanwnag\\hzzn.group.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__